import { useLocation, useParams, Routes, Route, Navigate } from 'react-router-dom'
import Page from '../../components/layouts/page'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import useStore from '../../hooks/use_store'
import Details from './details'
import ItemsTable from './items_table'

const Category = () => {
  const { pathname } = useLocation()
  const { categoryID, airlineID } = useParams()
  const constrainContent =
    pathname.includes('/sections/') ||
    pathname.includes('/categories/') ||
    pathname.includes('/ads/ad-pools/') ||
    pathname.includes('/ads/slate-groups/')
  const { data: airline, isLoading: isAirlineLoading } = useQuery(['airlines/', airlineID])

  const queryClient = useQueryClient()
  const { updateModel } = useStore()
  const queryKey = ['categories/', categoryID]
  const { data: category, isLoading } = useQuery(queryKey)

  const update = (value, isLocal, callbacks = {}) => {
    if (isLocal) {
      queryClient.setQueryData(queryKey, () => ({
        ...category,
        ...value,
      }))
    } else {
      updateModel.mutate(
        {
          endpoint: 'categories',
          id: categoryID,
          data: value,
        },
        callbacks
      )
    }
  }

  const isAdRelated = category?.type === 'warning-slates' || category?.type === 'ad-pools'
  const isSection = category?.type === 'categories'
  const adList = category?.type === 'warning-slates' ? 'slate-groups' : 'ad-pools'
  const adListLabel = category?.type === 'warning-slates' ? 'Slate Groups' : 'Ad Pools'
  const breadcrumbParent = isAdRelated
    ? {
        text: adListLabel,
        to: `/airlines/${category?.airline_id}/cycles/${category?.cycle_id}/ads/${adList}`,
      }
    : isSection
      ? {
          text: 'Sections',
          to: `/airlines/${category?.airline_id}/cycles/${category?.cycle_id}/sections`,
        }
      : {
          text: 'Categories',
          to: `/airlines/${category?.airline_id}/cycles/${category?.cycle_id}/categories`,
        }

  return (
    <Page
      className={constrainContent ? 'cs-page-narrow' : undefined}
      pending={isLoading || isAirlineLoading}
      breadcrumbs={[
        breadcrumbParent,
        { text: `${category?.category_values.find((v) => v.language_id === airline?.languages[0].id)?.value || ''}` },
      ]}
      tabs={[
        { name: 'Details', to: 'details' },
        { name: isSection ? 'Categories' : 'Items', to: 'items' },
        category?.type === 'categories' && { name: 'Featured Content', to: 'featured-content' },
        (category?.type === 'warning-slates' || category?.type === 'ad-pools') && {
          name: 'Assigned Assets',
          to: 'assets',
        },
      ].filter(Boolean)}
    >
      <Routes>
        <Route
          path='/items'
          element={
            <ItemsTable
              invalidateKey={queryKey}
              category={category}
              itemsKey={'category_items'}
              langID={airline?.languages[0].id}
            />
          }
        />
        <Route
          path='/details'
          element={<Details invalidateKey={queryKey} category={category} update={update} airline={airline} />}
        />
        <Route
          path='/assets'
          element={
            <ItemsTable
              invalidateKey={queryKey}
              category={category}
              itemsKey={'assigned_items'}
              langID={airline?.languages[0].id}
            />
          }
        />
        <Route
          path='/featured-content'
          element={
            <ItemsTable
              invalidateKey={queryKey}
              category={category}
              itemsKey={'featured_content'}
              langID={airline?.languages[0].id}
            />
          }
        />
        <Route path='*' element={<Navigate to='details' replace={true} />} />
      </Routes>
    </Page>
  )
}

export default Category
